<template>
    <!--  -->
    <div class="relative flex flex-col min-w-0 break-words bg-white rounded box-3">
        <!--  -->
        <div class="flex h-full w-full flex-col rounded-lg border border-b-4 border-border-200 bg-light p-5 md:p-6" v-bind:style="{ 'border-bottom-color': generateNewColor() }">
            <!--  -->
            <div class="mb-auto flex w-full items-center justify-between">
                <!--  -->
                <div class="flex h-14 w-16 shrink-0 items-center justify-center rounded bg-gray-200 me-3">
                    <div v-html="$icons[title]"></div>
                </div>
                <!--  -->

                <!--  -->
                <div class="flex flex-col text-right">
                    <!--  -->
                    <span class="mb-1 text-md font-light text-body">
                        {{ title }}
                    </span>
                    <!--  -->

                    <!--  -->
                    <div class="flex flex-col">
                        <span class="mb-2 text-xl font-normal text-heading">{{ sum }} 
                            <small class="text-sm">{{ currency }}</small>
                        </span>
                        <span class="font-normal text-xs text-gray-700">({{ count }} orders)</span>
                    </div>
                    <!--  -->
                </div>
                <!--  -->
            </div>
            <!--  -->
        </div>
        <!--  -->
    </div>
    <!--  -->
</template>

<script>
export default {
    props: {
        icon: '',
        title: {
            type: String,
        },
        currency: {
            type: String,
        },
        sum: {},
        count: {
            type: Number,
        }
    },
    data() {
        return {}
    },
    async mounted() {
    },
    computed: {
    },
    methods: {
        generateNewColor() {
            const hexCharacters = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, "A", "B", "C", "D", "E", "F"]
            let hexColorRep = "#"
            for (let index = 0; index < 6; index++) {
                const randomPosition = Math.floor(Math.random() * hexCharacters.length)
                hexColorRep += hexCharacters[randomPosition]
            }
            return hexColorRep
        }
    }
}
</script>